// src/pages/Users/TechniquesQuizz/QuizHeader.jsx
import React from "react";
import { FaQuestionCircle } from "react-icons/fa";

export default function QuizHeader({ title, subtitle }) {
  return (
    <div className="bg-gradient-to-r from-blue-500 via-violet-500 to-pink-500">
      <div className="px-5 py-6 sm:px-8 text-white">
        <div className="flex items-center gap-3 justify-center">
          <div className="h-10 w-10 rounded-xl bg-white/20 flex items-center justify-center">
            <FaQuestionCircle />
          </div>
          <h1 className="text-lg sm:text-xl font-semibold">{title}</h1>
        </div>
        {subtitle && (
          <p className="text-sm/6 opacity-95 text-center mt-2">{subtitle}</p>
        )}
      </div>
    </div>
  );
}
